import { Injectable, inject, signal } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

export interface Breadcrumb {
  label: string;
  url: string;
}

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private readonly router = inject(Router);
  readonly breadcrumbs = signal<Breadcrumb[]>([]);

  initialize(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const crumbs = this.buildBreadcrumbs(this.router.routerState.snapshot.root);
        this.breadcrumbs.set([{ label: 'Acasa', url: '/' }, ...crumbs]);
      });
  }

  private buildBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = '',
    crumbs: Breadcrumb[] = [],
  ): Breadcrumb[] {
    const path = route.url.map(segment => segment.path).join('/');
    const nextUrl = path ? `${url}/${path}` : url;
    const label = route.data['breadcrumb'] as string | undefined;

    if (label) {
      crumbs.push({ label, url: nextUrl });
    }

    if (route.firstChild) {
      return this.buildBreadcrumbs(route.firstChild, nextUrl, crumbs);
    }

    return crumbs;
  }
}
